module.exports = __webpack_public_path__ + "static/media/farm.f0466ffd.png";